import * as React from "react";
import {
  WithStyles,
  withStyles,
  StyleRulesCallback
} from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";

interface IProps {}

const styles: StyleRulesCallback = ({ palette, spacing }) => ({
  container: {
    fontSize: 16,
    color: palette.common.white,
    fontWeight: 300
  },
  field: {
    color: "#66D9EF"
  },
  technology: {
    color: "#F92672"
  }
});

@(withStyles(styles) as any)
export default class JobsTechStack extends React.Component<
  IProps & Partial<WithStyles<any>>
> {
  public render() {
    const { container, field, technology } = this.props.classes!;
    return (
      <Typography className={container}>
        - <span className={field}>Serverless</span>{" "}
        <span className={technology}>Google Cloud Functions</span>
        <br />- <span className={field}>Typescript</span>{" "}
        <span className={technology}>v3</span>
        <br />- <span className={field}>Frontend</span>{" "}
        <span className={technology}>React 16</span>,{" "}
        <span className={technology}>Redux</span>
        <br />- <span className={field}>Backend</span>{" "}
        <span className={technology}>Node.js</span>
        <br />- <span className={field}>Testing</span>{" "}
        <span className={technology}>Mocha</span>
      </Typography>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/JobsTechStack.tsx